import React, { useState } from "react";
import { Link, useNavigate } from "react-router";
import { createCollection } from "../../utils/api";
import { FaPlus, FaTimes } from "react-icons/fa";
import "./Home.css";
import { useScenes } from "../../context/ScenesContext";

const Plus = FaPlus as unknown as React.FC;
const Times = FaTimes as unknown as React.FC;

export default function Home() {
  const navigate = useNavigate();
  const { collections, scenes, refreshCollections } = useScenes();
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [newCollection, setNewCollection] = useState({
    name: "",
    client: "",
    description: ""
  });

  const handleCreateCollection = async () => {
    if (!newCollection.name.trim() || !newCollection.client.trim()) {
      alert("Collection name and client are required.");
      return;
    }
    try {
      const result = await createCollection(newCollection.name, newCollection.client, newCollection.description || undefined);
      setShowCreateModal(false);
      setNewCollection({ name: "", client: "", description: "" });
      refreshCollections();
      navigate(`/collection/${result.id}`);
    } catch (error) {
      console.error("Error creating collection:", error);
      alert("Failed to create collection. Please try again.");
    }
  };

  return (
    <div className="page-shell home-container">
      <h1 className="page-title">AR Postcard Dashboard</h1>
      <p className="page-subtitle">Manage AR postcard collections, scenes, and view analytics.</p>

      <section className="home-section">
        <div className="section-header">
          <h2 className="section-title">Latest Collections</h2>
          <button 
            className="btn-ark icon-btn" 
            onClick={() => setShowCreateModal(true)}
          >
            <Plus /> Create Collection
          </button>
        </div>
        {collections.length > 0 ? (
          <ul className="home-scene-list">
            {collections.map((collection) => (
              <li className="home-scene-item" key={collection.id}>
                <Link className="home-scene-link" to={`/collection/${collection.id}`}>
                  <div className="home-scene-info">
                    <span className="home-scene-name">{collection.name}</span>
                    <span className="home-scene-meta">{collection.client}</span>
                  </div>
                  <span className="home-scene-count">{collection.scenesCount} scenes</span>
                </Link>
              </li>
            ))}
          </ul>
        ) : (
          <p className="empty-state">No collections found yet.</p>
        )}
      </section>

      <section className="home-section">
        <h2 className="section-title">Latest Updated Scenes</h2>
        {scenes && scenes.length > 0 ? (
          <ul className="home-scene-list">
            {scenes.map((scene) => (
              <li className="home-scene-item" key={scene.id}>
                <Link className="home-scene-link" to={`/collection/${scene.collection_id}/${scene.id}`}>
                  <div className="home-scene-info">
                    <span className="home-scene-name">{scene.scene_name}</span>
                    <span className="home-scene-meta">
                      Updated {new Date(scene.updated).toLocaleDateString()}
                    </span>
                  </div>
                  <span className="home-scene-count">{scene.cardsCount || 0} cards</span>
                </Link>
              </li>
            ))}
          </ul>
        ) : (
          <p className="empty-state">No scenes found yet.</p>
        )}
      </section>

      <div className="home-actions">
        <Link to="/new" className="add-new-cards btn-ark">
          Add New Cards
        </Link>
      </div>

      {showCreateModal && (
        <div className="modal-overlay" onClick={() => setShowCreateModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2 className="modal-title">Create New Collection</h2>
              <button 
                className="modal-close" 
                onClick={() => setShowCreateModal(false)}
              >
                <Times />
              </button>
            </div>
            <div className="modal-body">
              <div className="form-group">
                <label htmlFor="name">Collection Name*</label>
                <input
                  type="text"
                  id="name"
                  value={newCollection.name}
                  onChange={(e) => setNewCollection({ ...newCollection, name: e.target.value })}
                  placeholder="Enter collection name"
                  autoFocus
                />
              </div>
              <div className="form-group">
                <label htmlFor="client">Client*</label>
                <input
                  type="text"
                  id="client"
                  value={newCollection.client}
                  onChange={(e) => setNewCollection({ ...newCollection, client: e.target.value })}
                  placeholder="Enter client name"
                />
              </div>
              <div className="form-group">
                <label htmlFor="description">Description</label>
                <textarea
                  id="description"
                  rows={4}
                  value={newCollection.description}
                  onChange={(e) => setNewCollection({ ...newCollection, description: e.target.value })}
                  placeholder="Enter description (optional)"
                />
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn-ark" onClick={handleCreateCollection}>
                Create
              </button>
              <button 
                className="btn-secondary" 
                onClick={() => setShowCreateModal(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
